import { render, staticRenderFns } from "./Matchmaking.vue?vue&type=template&id=0fabd746&"
import script from "./Matchmaking.vue?vue&type=script&lang=js&"
export * from "./Matchmaking.vue?vue&type=script&lang=js&"
import style0 from "./Matchmaking.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Matchmaking.vue"
export default component.exports